import styled from "styled-components";
import Footer from "../loggedOut/landingPage/Footer";
import { useContext } from "react";
import Context from "../../../Context";
import { useTranslation } from "react-i18next";
import LoginWall from "./LoginWall";
import { motion } from "framer-motion";
import SwipeBack from "./SwipeBackGesture";
import AnimatedPage from "./AnimatedPage";
import { Capacitor } from "@capacitor/core";
import WithBackground from "../../core/boilerplate/WithBackground";
import LoggedInTopBar from "./LoggedInTopBar";
import MessageBox from "../../helperComponents/MessageBox";
import CustomButton from "../../helperComponents/CustomButton";
import logout from "../../../controllers/logout";

const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Gap = styled.div`
  display: flex;
  height: 100px;
`;

const MainContent = styled.div`
  width: 100%;
  @media (max-width: 900px) {
    padding: 25px;
    padding-right: 15px;
  }
`;

export default function LoggedInBoilerplate({
  children,
  showFooter,
  allowWithoutLogin,
  titleLine1,
  titleLine2,
  showBackButton,
  isHome,
}) {
  const { loggedInUserId, loggedInUser } = useContext(Context);
  const { t } = useTranslation();

  if (!loggedInUserId && !allowWithoutLogin) return <LoginWall />;

  if (loggedInUser) {
    if (loggedInUser.isBanned) {
      return (
        <Main>
          <MessageBox> You have been banned </MessageBox>
          <CustomButton onClick={logout}>Logout</CustomButton>
        </Main>
      );
    }
  }

  return (
    <SwipeBack>
      <AnimatedPage>
        <Main>
          <LoggedInTopBar
            isHome={isHome}
            showBackButton={showBackButton}
            titleLine1={titleLine1}
            titleLine2={titleLine2}
          />

          <MainContent>
            {children}
            <Gap />
            {showFooter ? <Footer /> : null}
          </MainContent>
        </Main>
      </AnimatedPage>
    </SwipeBack>
  );
}
